import { useState } from 'react';
import { useQuery } from '@apollo/client';

import { GET_VALUESET } from '../gqlSchemes/getValueset';

interface ValuesetProps {
  url: string;
  language: string;
  filter: {
    text: string;
  };
  perPage?: number;
}

const useGetValueset = ({
  url,
  filter,
  language,
  perPage = 20,
}: ValuesetProps) => {
  const [valueset, setValueset] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(true);
  const { loading, fetchMore } = useQuery(GET_VALUESET, {
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    variables: {
      url,
      filter,
      language,
      page: 0,
      perPage,
    },
    onCompleted: (res) => {
      setValueset(res?.valueset?.valuesetConcepts?.items);
      setPage(1);
      setHasNextPage(res?.valueset?.valuesetConcepts?.pageInfo?.hasNextPage);
    },
  });

  const loadMore = () => {
    if (!hasNextPage) return;
    fetchMore({
      variables: {
        url,
        filter,
        page: page,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        const fetchedItems = fetchMoreResult?.valueset?.valuesetConcepts?.items;
        setValueset((curr: any) => [...curr, ...fetchedItems]);
        setPage(page + 1);
        setHasNextPage(
          fetchMoreResult?.valueset?.valuesetConcepts?.pageInfo?.hasNextPage
        );
      },
    });
  };

  return {
    valueset,
    setValueset,
    loading,
    loadMore,
  };
};
export default useGetValueset;
